import find from 'lodash/find';
import { writable, get } from 'svelte/store';
export default class DataProvider {
    constructor(branchId, options) {
        this._activityId = null;
        this._hash = null;
        this._date = null;
        this._time = null;
        this._fullName = null;
        this._email = null;
        this._phone = null;
        this._mmb_rz_tp = null;
        this._branchId = branchId;
        this._options = options;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        this._individualForms = writable([]);
    }
    set individualForms(data) {
        this._individualForms.set(data);
    }
    get individualForms() {
        return get(this._individualForms);
    }
    get isMmbRzSp() {
        const key = "mmb_rz_tp";
        return find(this.individualForms, (item) => item.label === key) || null;
    }
    get branchId() {
        return this._branchId;
    }
    get numberOfFollowingDays() {
        const branchDaysMap = {
            2: 25,
            3: 35,
            4: 21,
            5: 21, // Odbor dopravy
        };
        return branchDaysMap[this.branchId] || 35;
    }
    get displayOsc() {
        return this._options.osc;
    }
    get occupancyCountersId() {
        return this._options.occupancyCountersId;
    }
    set activityId(activityId) {
        this._activityId = activityId;
    }
    get activityId() {
        return this._activityId;
    }
    set hash(hash) {
        this._hash = hash;
    }
    get hash() {
        return this._hash;
    }
    set date(date) {
        this._date = date;
    }
    get date() {
        return this._date;
    }
    set time(time) {
        this._time = time;
    }
    get time() {
        return this._time;
    }
    set fullName(fullName) {
        this._fullName = fullName;
    }
    get fullName() {
        return this._fullName;
    }
    set email(email) {
        this._email = email;
    }
    set mmb_rz_tp(value) {
        this._mmb_rz_tp = value;
    }
    get email() {
        return this._email;
    }
    set phone(phone) {
        this._phone = phone;
    }
    get phone() {
        return this._phone;
    }
    // eslint-disable-next-line @typescript-eslint/adjacent-overload-signatures
    get mmb_rz_tp() {
        return this._mmb_rz_tp;
    }
    get reservationData() {
        return {
            fullName: this._fullName,
            phone: this._phone,
            email: this._email,
            branchId: this._branchId,
            activityId: this._activityId,
            mmb_rz_tp: this._mmb_rz_tp
        };
    }
    get reservationRequestData() {
        const data = {
            jmeno: this._fullName,
            prijmeni: this._fullName,
            telefon: this._phone,
            email: this._email,
            pobockaId: this._branchId,
            cinnostId: this._activityId,
            cas: this._time,
            den: this._date,
            poznamka: null
        };
        if (this.isMmbRzSp) {
            data.ifObsah = [this.mmb_rz_tp];
            data.ifNazev = [String(this.isMmbRzSp.id)];
        }
        return data;
    }
    clear() {
        this._fullName = null;
        this._phone = null;
        this._email = null;
        this._activityId = null;
        this._branchId = null;
        this._mmb_rz_tp = null;
        this._individualForms.set([]);
    }
}
